import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "mt-3 text-primary"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-3 text-danger"
}

import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import storeCliente from "@/utils/storeCliente";
import { getToken } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import { di } from "@fullcalendar/core/internal-common";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {


//vue
const router = useRouter();

var controle = reactive({
  model: {} as clienteService.ClienteLogin,
  status: "" as string,
  erro: "" as string
})


function login() {

  // Lógica de login aqui
  controle.status = "Realizando login...";
  console.log("Login:", controle.model);

  clienteService.Login(controle.model)
    .then((r) => {
      storeCliente.usuario = {} as clienteService.ClienteLoginResult;
      storeCliente.token = r.accessToken;
      storeCliente.usuario.clienteId = r.clienteId;
      storeCliente.usuario.nome = r.nome;
      storeCliente.usuario.refreshToken = r.refreshToken;
      storeCliente.usuario.userName = r.userName;

      controle.status = "Entrando...";
      console.log("Entrando com sucesso:", r);

      // Armazenar o token no localStorage ou cookies, se necessário
      localStorage.setItem("clienteToken", r.accessToken);

      // Redirecionar para a área do cliente após o login bem-sucedido
      
      router.push({ name: "PainelCliente" });
    })
    .catch((error) => {
      controle.status = "";
      controle.erro =  error.message || error;
    });
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-3" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-md-12 text-center" }, [
            _createElementVNode("h2", { class: "mt-4 mb-3" }, "Área do Cliente - Login")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(imgLogin),
              alt: "Login do Cliente",
              class: "img-fluid"
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "cpf",
              class: "form-label"
            }, "CPF", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              id: "cpf",
              placeholder: "Digite seu CPF",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).model.cpf) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).model.cpf]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              for: "senha",
              class: "form-label"
            }, "Senha", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              id: "senha",
              placeholder: "Digite sua senha",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).model.senha) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).model.senha]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (login()))
          }, "Entrar"),
          (_unref(controle).erro == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(controle).status), 1))
            : _createCommentVNode("", true),
          (_unref(controle).erro != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(controle).erro), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-3" }, null, -1))
    ])
  ], 64))
}
}

})